import { render, staticRenderFns } from "./UnassignedReviewCard.vue?vue&type=template&id=15b6e680"
import script from "./UnassignedReviewCard.vue?vue&type=script&lang=ts"
export * from "./UnassignedReviewCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports